import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAppSelector } from 'app/hooks';

const ProtectedRoute = () => {
  const navigate = useNavigate();

  const { accessToken } = useAppSelector(state => state.auth);

  useEffect(() => {
    if (!accessToken) {
      navigate('/login', { replace: true });
    }
  }, [accessToken, navigate]);

  if (!accessToken) {
    return null;
  }

  return <Outlet />;
};

export default ProtectedRoute;
